import React from "react";
import { NAV_LINKS } from "../../../config/consts";
import { DesktopNavLink } from "./elements/DesktopNavLink";
import { GlobalStore } from "../../../store/global/GlobalStore";

interface NavLinksProps {
  isVisible: boolean;
}

export const NavLinks: React.FC<NavLinksProps> = props => {
  const theme = GlobalStore.useState(s => s.theme);
  if (!props.isVisible) {
    return null;
  }
  return (
    <div className={`align-items-center`}>
      <DesktopNavLink href={NAV_LINKS.DISCORD} target="_blank" rel="noreferrer" theme={theme}>
        Discord
      </DesktopNavLink>
      <DesktopNavLink href={NAV_LINKS.TWITTER} target="_blank" rel="noreferrer" theme={theme}>
        Twitter
      </DesktopNavLink>
      <DesktopNavLink href={NAV_LINKS.BLOG} target="_blank" rel="noreferrer" theme={theme}>
        Blog
      </DesktopNavLink>
      <DesktopNavLink href={NAV_LINKS.FAQ} target="_blank" rel="noreferrer" theme={theme}>
        FAQs
      </DesktopNavLink>
    </div>
  );
};
